// extracted by mini-css-extract-plugin
export default {"switch-holder":"switch-holder","heading-popover":"heading-popover","active-popover":"active-popover","popover-icon":"popover-icon","form-switch-holder":"form-switch-holder"};